function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { setupSlider } from '@bytel/trilogy-slider/lib/trilogy-slider.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from 'react';
import { withModifiers } from '../../decorators';
import Columns from '../columns';
import Icon from '../icon';
import Text from '../text';
import SliderItem from './item';

var Slider = function Slider(_ref) {
  var children = _ref.children,
      className = _ref.className,
      forceControl = _ref.forceControl,
      others = _objectWithoutProperties(_ref, ["children", "className", "forceControl"]);

  var sliderRef = useRef();
  useEffect(function () {
    if (!forceControl) setupSlider(sliderRef.current);
  }, [forceControl]);
  return React.createElement("div", _extends({
    ref: sliderRef,
    className: classNames(className)
  }, others, {
    "data-slider": ""
  }), Array.from(children).length >= 2 && // children
  React.createElement(React.Fragment, null, React.createElement(Columns, {
    "is-vcentered": true,
    "is-flex": true
  }, React.createElement(Columns.Item, {
    "is-narrow": true
  }, React.createElement(Icon, {
    name: "ui-arrow-left-r",
    "data-slider-prev": ""
  })), React.createElement(Columns.Item, null, React.createElement(Columns, {
    "is-8-mobile": true,
    "is-clipped": true,
    "data-slider-pages": ""
  }, children && typeof children.valueOf() === 'string' ? React.createElement(Slider.Text, {
    content: children
  }) : children)), React.createElement(Columns.Item, {
    "is-narrow": true
  }, React.createElement(Icon, {
    name: "ui-arrow-right-r",
    "data-slider-next": ""
  }))), React.createElement("div", {
    className: "has-text-centered is-fullwidth"
  }, React.createElement("div", {
    className: "is-dark",
    "data-slider-dots": ""
  }))), Array.from(children).length < 2 && // single child
  React.createElement(React.Fragment, null, React.createElement(Columns, {
    "is-vcentered": true,
    "is-flex": true
  }, children && typeof children.valueOf() === 'string' ? React.createElement(Slider.Text, {
    content: children
  }) : children)));
};

Slider.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  forceControl: PropTypes.bool
};
Slider.Item = SliderItem;
Slider.Text = Text;
export default withModifiers(Slider);
